import React, { Component } from 'react';
import { Modal, Spin, Button, message } from 'antd';
import TableC from '../../basicElement/TableC';
import format from '../../shared/format';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';

const CONSTANTS = {
    DAILYMANAGEMENT: '日常管理',
    TOTAL: '合计',
    true: {
        loadDataURL: API_URL.manhour.queryInvDetailList,
        getColumns: `getColumnsByInvestigation`,
    },
    false: {
        loadDataURL: API_URL.manhour.queryDailyDetailList,
        getColumns: `getColumnsByDailyManagement`,
    }
};

class UnconfrimManhourSummary extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        isInvestigation: false,
        canSetNoConfirm: false,
    }

    show = record => {
        const { investigationName } = record;
        this.setState({
            record,
            data: [],
            visible: true,
            isInvestigation: investigationName !== CONSTANTS.DAILYMANAGEMENT,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        const { record, isInvestigation } = this.state;
        const { investigationId, yearNum, monthNum } = record;
        this.setState({ loading: true });
        Fetch.post(CONSTANTS[isInvestigation].loadDataURL, {
            yearNum,
            monthNum,
            investigationId,
        }).then(res => {
            const { data, canSetNoConfirm } = res;
            this.setState({
                data,
                loading: false,
                canSetNoConfirm,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    confirmDirectly = record => {
        Modal.confirm({
            iconType: 'exclamation-circle',
			title: <div style={{ marginLeft: 42 }}>确认此项目下该条工时汇总记录，在该月无需继续确认？</div>,
			content: '标记为无需继续确认，那么该项目下该条工时汇总记录，不再出现在该项目的未确认工时汇总记录列表',
            onOk: () => {
                const { summaryId, investigationId } = record;
				Fetch.post(API_URL.manhour.setNotNeedCheck, {
                    summaryId,
                    investigationId,
                }).then(res => {
                    const { success } = res;
                    message.success(success);
                    this.loadData();
                    this.props.loadData();
                }).catch(err => {
                    console.error(err);
                });
            }
        });
    }

    enhanceRender = (func) => {
        return (...rest) => {
            const [text, record] = rest;
            const { userCompellation } = record;

            const result = func ? func.apply(null, rest) : text;
            if (userCompellation === CONSTANTS.TOTAL) {
                return <strong>{result}</strong>;
            } else {
                return result;
            }
        }
    }

    getColumnsByInvestigation = () => {
        const { canSetNoConfirm } = this.state;
        const columns = [{
            title: '录入者',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 80,
            render: this.enhanceRender(),
        }, {
            title: '录入者工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 80,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 120,
        }, {
            title: '角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 80,
        }, {
            title: '用时/FTE',
            dataIndex: 'fte',
            key: 'fte',
            width: 100,
            render: this.enhanceRender((text, record) => {
                const { fte, manHour } = record;
                return `${(manHour || 0).toFixed(2)}h/${fte}`;
            }),
        }, {
            title: '实际访视数',
            dataIndex: 'visitCount',
            key: 'visitCount',
            width: 80,
            render: this.enhanceRender(),
        }, {
            title: '访视数分配系数',
            dataIndex: 'assignWeight',
            key: 'assignWeight',
            width: 80,
            render: this.enhanceRender(),
        }, {
            title: '标准访视数',
            dataIndex: 'visitStandardAmount',
            key: 'visitStandardAmount',
            width: 80,
            render: this.enhanceRender(),
        }];
        if (canSetNoConfirm) {
            columns.push( {
                title: '操作',
                key: 'operation',
                fixed: 'right',
                width: 100,
                render: (text, record) => {
                    const { userCompellation } = record;
                    if (userCompellation !== CONSTANTS.TOTAL) {
                        return <a onClick={() => this.confirmDirectly(record)}>无需继续确认</a>;
                    }
                }
            });
        }
        return columns;
    }

    getColumnsByDailyManagement = () => {
        const { canSetNoConfirm } = this.state;
        const columns = [{
            title: '录入者',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 80,
            render: this.enhanceRender(),
        }, {
            title: '录入者工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 80,
        }, {
            title: '主管领导',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 80,
        }, {
            title: '主管领导工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 80,
        }, {
            title: '角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 80,
        }, {
            title: '用时/FTE',
            dataIndex: 'fte',
            key: 'fte',
            width: 100,
            render: this.enhanceRender((text, record) => {
                const { fte, manHour } = record;
                return `${(manHour || 0).toFixed(2)}h/${fte}`;
            }),
        }];
        if (canSetNoConfirm) {
            columns.push( {
                title: '操作',
                key: 'operation',
                fixed: 'right',
                width: 100,
                render: (text, record) => {
                    const { userCompellation } = record;
                    if (userCompellation !== CONSTANTS.TOTAL) {
                        return <a onClick={() => this.confirmDirectly(record)}>无需继续确认</a>;
                    }
                },
            });
        }
        return columns;
    }

    render() {
        const { data, visible, loading, record, isInvestigation } = this.state;
        const { yearNum, monthNum, investigationName } = record;
        return (
            <Modal
                title="未确认工时汇总记录"
                visible={visible}
                onCancel={this.hide}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
                bodyStyle={{maxHeight: 500}}
                maskClosable={false}
                width="1000px"
            >
                <Spin spinning={loading}>
                    <div>
                        <div style={{ marginBottom: 10 }}>
                            工时时间：{format('month', yearNum, monthNum)}
                            <span className="ant-divider" />
                            项目简称 ：{investigationName}
                        </div>
                        <TableC
                            data={data}
                            scrollY={390}
                            columns={this[CONSTANTS[isInvestigation].getColumns]()}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default UnconfrimManhourSummary;


// WEBPACK FOOTER //
// ./src/components/manHour/unconfirmProManhour/Widget.js